import { useUserStore } from "@/stores/useUser";
import { useSessionStore } from "@/entities/Session/model";

/**
 * Проверяет состояние авторизации при загрузке приложения
 * Восстанавливает данные из localStorage
 */
export function checkAuthState(): boolean {
    const userStore = useUserStore();
    const sessionStore = useSessionStore();
    
    // Данные уже загружены из localStorage при инициализации stores
    const isAuthenticated = userStore.isAuthenticated() && sessionStore.isAuthenticated();
    
    if (isAuthenticated) {
        console.log("Пользователь уже авторизован");
        return true;
    } else {
        console.log("Пользователь не авторизован");
        return false;
    }
}

/**
 * Проверяет валидность токена (можно расширить логикой проверки на сервере)
 */
export function isTokenValid(): boolean {
    const sessionStore = useSessionStore();
    return sessionStore.isAuthenticated();
}
